
<div class="slic-container">
  <div class="slic-content">
    <div class="slic-icon-circle" [class.slic-icon-circle-warn]="isUnshareAction()">
      <i class="bi" [ngClass]="isUnshareAction() ? 'bi-person-x-fill' : 'bi-share'"></i>
    </div>

    <h2 class="slic-title">{{ isUnshareAction() ? 'Confirm Unsharing' : 'Confirm Sharing' }}</h2>

    <div class="slic-text">
      <p class="slic-line">
        Are you sure you want to {{ getActionTitle() }}
        <span class="slic-doc-name">{{ getDocumentName() }}</span>
      </p>
      <p class="slic-line">
        with <span class="slic-recipient-name">{{ getSelectedNames() }}</span> ?
      </p>
    </div>

    <div class="slic-info-box" *ngIf="!isUnshareAction()">
      <i class="bi bi-lock-fill"></i>
      <div class="slic-info-text">
        <p class="slic-info-title">They will be able to view the details you have shared.</p>
        <p class="slic-info-sub">You can revoke access anytime.</p>
      </div>
    </div>

    <div class="slic-actions">
      <button mat-button class="slic-cancel-btn" (click)="onCancel()">Cancel</button>
      <button mat-flat-button
              [color]="getConfirmButtonColor()"
              class="slic-confirm-btn"
              [class.slic-confirm-btn-warn]="isUnshareAction()"
              (click)="onConfirm()">
        {{ getConfirmButtonText() }}
      </button>
    </div>
  </div>
</div>